<template>
  <v-app class="view">
    <div :style="{
                        paddingLeft:(8)+'px',
                        paddingRight:(8)+'px',

                     }"
         class="list-header">
      <v-row
          class="list-header-row">
        <v-col v-if="!noSearch" class="col-2">
          <v-text-field v-model="filter_search_keyword"

                        class="search"
                        clearable
                        hide-details="true"
                        label="ค้นหา"
                        outlined
                        placeholder="ใส่คำค้นหา"
                        @click:clear="clear_reload()"
                        @keydown.enter="reload()"
          ></v-text-field>
        </v-col>
        <v-col>
          <!--<v-btn outlined tile class="status-btn">รอ</v-btn>-->
          <!--<v-btn outlined tile class="status-btn amber">ส่ง</v-btn>-->
          <!--<v-btn outlined tile class="status-btn orange">บิล</v-btn>-->
          <!--<v-btn outlined tile class="status-btn red">เลย</v-btn>-->
          <!--<v-btn outlined tile class="status-btn grey">เสร็จ</v-btn>-->
          <!--<v-btn outlined tile class="status-btn purple">ค้าง</v-btn>-->


          <FilterButton v-if="!is_pending" :clearFilter="clearFilter" :filter="store.filter"
                        :option-get-status-color="ShippingConst.color"
                        :setFilter="setFilter"></FilterButton>

<!--          <v-btn v-for="{text,key,count} in store.filter.status.options" v-if="false" :class="{-->
<!--                 'status-btn':true,-->
<!--                 'grey lighten-1':key === ShippingConst.STATUS_DRAFT || key === ShippingConst.STATUS_SUBMITTED_PENDING_APPROVE || key === ShippingConst.STATUS_APPROVED_PENDING_SYNC,-->
<!--                 'red':key === ShippingConst.STATUS_SUBMITTED_PENDING_CONFIRM || key === ShippingConst.STATUS_REJECT,-->
<!--                 'amber':key === ShippingConst.STATUS_SYNCED_PENDING_ACTIVE,-->
<!--                 'lime':key === ShippingConst.STATUS_DO_CONFIRMED_WAIT_STOCK || key === ShippingConst.STATUS_ISSUED_WAIT_LOAD,-->
<!--                 'light-green':key === ShippingConst.STATUS_ON_DELIVERY,-->
<!--                 'blue-grey':key === ShippingConst.STATUS_RETURN,-->
<!--                 }" outlined-->
<!--                 tile-->
<!--          >-->
<!--            {{ text }} ({{ count }})-->
<!--          </v-btn>-->
        </v-col>
        <v-col class="text-right  d-none d-md-inline">

          <v-btn
              class="title"
              ourlined tile @click="isPickingDate=!isPickingDate">
            {{ dateFrom }} - {{ dateTo }}
          </v-btn>
          <br/>
          ปุ่มลัด:
          <a href="#" @click="setDateLastMonth()">เดือนก่อน</a> &nbsp;
          <a href="#" @click="setDateThisMonth()">เดือนนี้</a> &nbsp;
          <a class="" href="#" @click="setDateToday()">วันนี้</a>

        </v-col>
      </v-row>
      <v-dialog v-model="isPickingDate"
                width="700"
      >
        <v-card>
          <v-card-title>เลือกวันที่ ตั้งแต่ ... ถึง ...
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-date-picker
                    v-model="dateFrom"
                    locale="th"
                ></v-date-picker>
              </v-col>
              <v-col>
                <v-date-picker
                    v-model="dateTo"
                    locale="th"
                ></v-date-picker>

              </v-col>
            </v-row>


          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="mr-4" color="gray" text @click="isPickingDate=false">
              cancel
            </v-btn>
            <v-btn class="close-button" color="primary" fab tile
                   @click="isPickingDate=false;reload()">
              <v-icon>mdi-check-bold</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </div>


    <v-content>

      <v-container
          class="fill-height container"
          fluid
      >

        <ShippingRow
            v-for="(shipping, index) in items"
            :key="index"
            :currentIndex="-padItemOffset+startElementIndex+index-padItemAmount"
            :shipping="shipping"
            :style="{top:((-padItemOffset+startElementIndex+index-padItemAmount)*itemHeight)+'px'}"
        >

        </ShippingRow>


        <LoadingDummy
            :itemHeight="itemHeight"
            :maxElementRender="maxElementRender"
            :scrollY="scrollY"
            :store="store">
        </LoadingDummy>

        <div :style="{top:(store.data?(store.data.length*itemHeight+40):40)+'px'}"
             class="dummy">

        </div>

      </v-container>
    </v-content>


    <div class="summary">

    </div>
  </v-app>
</template>
<style lang="scss" scoped>
.dummy {
  position: absolute;
  display: block;
  margin: auto;
  width: 40px;
  height: 40px;
}

.summary {
  position: fixed;
  bottom: 0;
  display: block;
  height: 40px;
  width: 100%;
  text-align: right;
  padding: 8px;
}

.theme--light .summary {
  background: #FFFFFF;
}

.theme--dark .summary {
  background: #000000;
}

.view {
  font-size: 18px;
}

.nav {
  z-index: 1;
}

.container {
  position: relative;
  margin-top: 80px;
  /*margin-bottom: 40px;*/
  /*min-width: 750px;*/
}

@media (max-height: 700px) {

}

.pad-filter {
  padding: 16px 0 0 24px;
}

.search .v-input__control {
  /*height: 60px;*/
}

.list-header {
  position: fixed;
  top: 60px;
  z-index: 1;
  width: 100%;

}

.theme--light .list-header-row {
  background: #FFFFFF;
}

.theme--dark .list-header-row {
  background: #000000;
}

.status-btn {
  font-weight: bold;
  font-size: 20px;
  min-width: 36px !important;
  padding: 2px 4px 4px !important;
  margin-right: 4px;
}

</style>
<script lang="ts">
import {Route} from '@/models/Route'
import {Component, Prop} from 'vue-property-decorator'
import FilterButton from '../components/FilterButton.vue'
import LoadingDummy from '../components/LoadingDummy.vue'
import ShippingRow from '../components/Shipping/ShippingRow.vue'
import {Shipping, ShippingConst} from '../models/Shipping'
import {UserConst} from '../models/User'
import Helper from '../services/Helper.js'
import ListView from './ListView'

@Component({
  components: {LoadingDummy, ShippingRow, FilterButton},
})
export default class ViewShipping extends ListView<Shipping> {
  @Prop() noSearch: boolean


  ShippingConst = ShippingConst
  isPickingDate = false


  store = this.$store.state.shipping

  drawer_ratio = 0.2

  commit_prefix = 'shipping'
  base_url = Helper.setting.shipping.getListAPI

  isForceReload = true

  get isApproveComOptionAble() {
    switch (this.$store.state.$user.role) {
      case UserConst.ROLE_ADMIN:
        return true
      case UserConst.ROLE_CEO:
        return true
      case UserConst.ROLE_DIRECTOR:
        return true
      default:
        return false
    }


  }


  beforeLoad() {
    // if (this.$route.params.status) {
    //   this.setFilter('status', this.$route.params.status)
    // }
    if (this.$route.params.status) {
      this.store.filter['status'].current.push({
        key: this.$route.params.status,
        text: this.$route.params.status,
        count: 0,
      })
    }
    if (this.$route.params.from) {
      this.dateFrom = this.$route.params.from
      this.store.dateFrom = this.dateFrom
    }
    if (this.$route.params.to) {
      this.dateTo = this.$route.params.to
      this.store.dateTo = this.dateTo
    }
  }

  onListLoaded(data) {
    if (this.$route.params.id) {
      console.log('onListLoaded', data)
      let index: number = -1

      for (let i in data.data) {
        const shipping: Shipping = data.data[i]
        if (shipping.id == parseInt(this.$route.params.id)) {
          index = parseInt(i)
        }
      }


      if (index >= 0) {
        this.$store.commit('dialog_is_shipping', {toggle: true, index: index})
      }
    }
    return
  }

  setDateLastMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    // let tmpDateFrom = (new Date(Date.now() - tzoffset))
    var tmpDateFrom = new Date(Date.now())
    // tmpDateFrom.setMonth(tmpDateFrom.getMonth() - 1)
    tmpDateFrom.setDate(0)
    this.dateTo = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.reload()
  }

  setDateThisMonth() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    var tmpDateFrom = new Date(Date.now())
    tmpDateFrom.setDate(1)
    this.dateFrom = (new Date(tmpDateFrom.getTime() - tzoffset)).toISOString().substr(0, 10)
    this.dateTo = (new Date(Date.now() - tzoffset)).toISOString().substr(0, 10)
    this.reload()
  }

  setDateToday() {
    var tzoffset = (new Date()).getTimezoneOffset() * 60000
    let tmpDateFrom = (new Date(Date.now() - tzoffset))

    this.dateFrom = tmpDateFrom.toISOString().substr(0, 10)
    this.dateTo = tmpDateFrom.toISOString().substr(0, 10)
    this.reload()
  }

  async openRoute(object: Route) {
    this.$root.$emit('openRoute', {route: object})
  }

}
</script>
<style lang="scss" scoped>
.view {

  .fill-height {
    /*padding-left: 150px;*/
  }
}

.nav {
  position: fixed;
  margin-top: 60px;

}
</style>
